'use strict';

import Calculator from "./Calculator";
import KoeffsAndValues from "./KoeffsAndValues";

class Passp {
    constructor(initALL = true) {
        console.log('Init Passp module');
        if (initALL) this.initVars().initSubmitForm();
    }

    initVars() {
        return this;
    }

    initSubmitForm() {
        $("#printPasspForm,#printLabelForm").on("submit", (event) => {
            console.log("======================")
            console.log(this.options)
            let $form = $(event.target);
            $form.find("input[type='hidden']").filter(":not([name='_csrf'])").remove()
            $("<input type='hidden' name='data' value='" + JSON.stringify(this.options) + "'/>").appendTo($form);
            console.log($form)
        });
        return this;
    }

    get $dimensions() {
        let series = this.selection.series,
            variant = this.selection.variant,
            result = {
                $visota: $("#" + variant + "_visota"),
                $shirina: $("#" + variant + "_shirina")
            };
        if (variant === "ITTN" || variant === "ITTBN" || variant === "ITTLN" || variant === "ITTBLN" || variant === "ITTZN" || variant === "ITTBZN") {
            result.$dlina = $("#" + variant + "_dlina");
        } else if (variant === "ITTC" || variant === "ITTBC" || variant === "ITTLC" || variant === "ITTBLC" || variant === "ITTZC" || variant === "ITTBZC") {
            result.$dlina1 = $("#" + variant + "_dlina1");
            result.$dlina2 = $("#" + variant + "_dlina2");
            result.$dlina3 = $("#" + variant + "_dlina3");
            result.$ugol1 = $("#" + variant + "_ugol1");
            result.$ugol2 = $("#" + variant + "_ugol2");
        } else if (variant === "ITTR") {
            result.$dlina1 = $("#" + variant + "_dlina1");
            result.$dlina2 = $("#" + variant + "_dlina2");
        } else if (series === "ITF") {
            result.$visota = $("#" + series + "_visota");
            result.$shirina = $("#" + series + "_shirina");
            result.$dlina = $("#" + series + "_dlina");
        }

        return result;
    }
    get dimensions() {
        let $tmp = this.$dimensions,
            series = this.selection.series,
            variant = this.selection.variant,
            result = {
                visota: +$tmp.$visota.val(),
                shirina: +$tmp.$shirina.val()
            };

        if (variant === "ITTN" || variant === "ITTBN" || variant === "ITTLN" || variant === "ITTBLN" || variant === "ITTZN" || variant === "ITTBZN" || series === "ITF") {
            result.dlina = +$tmp.$dlina.val()
        } else if (variant === "ITTC" || variant === "ITTBC" || variant === "ITTLC" || variant === "ITTBLC" || variant === "ITTZC" || variant === "ITTBZC") {
            result.dlina1 = +$tmp.$dlina1.val();
            result.dlina2 = +$tmp.$dlina2.val();
            if (!$tmp.$dlina3.is(":disabled"))
                result.dlina3 = +$tmp.$dlina3.val();
            result.ugol1 = +$tmp.$ugol1.val();
            result.ugol2 = +$tmp.$ugol2.val();
        } else if (variant === "ITTR") {
            result.dlina1 = +$tmp.$dlina1.val();
            result.dlina2 = +$tmp.$dlina2.val();
        }

        return result;
    }
    get selection () {
        this.selected = {
            series: $('.convectors > .active').prop("id"),
            variant: $('.convectors > .active .variants > .active').prop("id"),
            previous: this.selected
        };

        return this.selected;
    }
    get options() {
        let selection = this.selection,
            result = {
                convector: selection.series,
                variant: selection.variant,
                isCorner: (selection.variant === "ITTC" || selection.variant === "ITTBC" || selection.variant === "ITTLC" || selection.variant === "ITTBLC" || selection.variant === "ITTZC" || selection.variant === "ITTBZC"),
                isRadial: (selection.variant === "ITTR"),
                isFloor: selection.series === "ITF",
                hasBlower: (selection.series === "ITTB" || selection.series === "ITTBL" || selection.series === "ITTBZ"),
                dimensions: this.dimensions,
                temperatures: Calculator.temperatures,
                Q: Calculator.Q,
                no_grill: $("#" + selection.variant + "_no-grill").is(":checked"),
                vent: $("#" + selection.series + "_vent").is(":checked"),
                G: $("#" + selection.series + "_option_g").is(":checked"),
                spec: $("#" + selection.series + "_spec").is(":checked"),
                drenazh: $("#" + selection.series + "_drenazh").is(":checked"),
                nerzh: $("#" + selection.series + "_nerzh").is(":checked"),
                F_frame: $("#" + selection.variant + "_f-frame").is(":checked"),
                Z_frame: $("#" + selection.variant + "_z-frame").is(":checked"),
            };
        result.weight = KoeffsAndValues.getConvectorWeight(result);
        result.volume = KoeffsAndValues.getConvectorVolume(result);


        if (result.isFloor) {
            result.frame_color = $("[name=" + selection.series + "_color]:checked").val();
            result.frame_ral_color = $("#" + selection.series + "_grill label.ral").data("ral");
        }
        else {
            result.frame_color = $("[name=" + selection.variant + "_color]:checked").val();
            result.frame_ral_color = $("#" + selection.variant + "_frame label.ral").data("ral");
        }

        if (!result.no_grill)
        {
            result.grill = $("[name=" + result.variant + "_grill]:checked").val();
            result.grill_color = $("[name=" + result.variant + "_grill_color]:checked").val();
            result.grill_ral_color = $("#" + selection.variant + "_grill label.ral").data("ral");
        }
        if (result.isFloor)
        {
            result.variant = "ITF";
            result.mount_scheme = $("[name=mount_scheme]:radio:checked").val();
            result.HWoptions = $("#" + selection.series + "_options").is(":checked");
            result.W = $("#" + selection.series + "_option_W").is(":checked");
            if (result.HWoptions && result.W) result.variant = "ITW";
            result.H = $("#" + selection.series + "_option_H").is(":checked");
            if (result.HWoptions && result.H) result.variant = "ITH";
            result.visota_nozhki = +$("#" + selection.series+ "_visota_nozhki").val();
        }

        result.artikul = this.getArtikul(result)
        result.grill_artikul = this.getGrillArtikul(result)


        return result;
    }

    getArtikul(opt) {
        let res = KoeffsAndValues.getArtikul(opt);
        if (opt.isCorner) {
            res+= ", " + KoeffsAndValues.getArtikul(opt, 2)
            if (opt.dimensions.dlina3) {
                res+= ", " + KoeffsAndValues.getArtikul(opt, 3)
            }
        }

        return res;
    }

    getGrillArtikul(opt) {
        let res;
        if (!opt.no_grill && !opt.isFloor) {
            res = KoeffsAndValues.getGrillArtikul(opt);
            if (opt.isCorner) {
                res+= ", " + KoeffsAndValues.getGrillArtikul(opt, 2)
                if (opt.dimensions.dlina3) {
                    res+= ", " + KoeffsAndValues.getGrillArtikul(opt, 3)
                }
            }
        }

        console.log(res);
        return res;
    }
}

export default Passp;